import React, { Suspense, useEffect } from "react"
import { Redirect, Switch } from "react-router-dom"
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout"
import { BuilderPage } from "./pages/BuilderPage"
import { DashboardPage } from "./modules/dashboard/DashboardPage.js"
import { PrivilegeAll } from "./service/userManagementAction"
import { AccountEditPassword } from "./modules/setting/account/form/edit-password/AccountEditPassword.jsx"
// import { PrintHeader } from "../create-user/molecule/Print/Print"
import { currentUrl, keepStateUrlParamActivity } from "./helpers/UrlParamHelper"
import { useDispatch, useSelector } from "react-redux"
import { resetUrlParam } from "../redux/actions/FilterAction"
import { CreateSubmissionPage } from "./modules/submission/certification-block/create-submission/CreateSubmissionPage.jsx"
import { CreateReportBaPage } from "./modules/report/ba/create-ba/CreateReportBaPage.jsx"

export default function BasePage() {
  const dispatch = useDispatch()
  const { UrlParam } = useSelector((state) => state)
  const routingFrom = PrivilegeAll()
  const url = currentUrl()

  useEffect(() => {
    const keepPage = keepStateUrlParamActivity(url)
    if (UrlParam.pageString !== url && keepPage) {
      dispatch(resetUrlParam())
    }
  }, [url])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      {/*<PrintHeader />*/}
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/account/edit-password" component={AccountEditPassword} />
        <ContentRoute path="/submission/create" component={CreateSubmissionPage} />
        <ContentRoute path="/report/create/ba" component={CreateReportBaPage} />
        {routingFrom.map((value, index) => {
          return <ContentRoute key={index} path={value.url} component={value.component} />
        })}
        <Redirect to="/error/opppsss" />
      </Switch>
    </Suspense>
  )
}
